export interface IOdataFilter {
  toFilterString(): any;
}
